
import { 
  FloatingFeature 
} from "@models";

/**
 * Modifies Transforms.  
 * It will apply to any transform that fits the filter, 
 * which currently I'm only planning to do based on _id and transform_type.
 * 
 * It works by applying overrides AFTER the Transform's overrides are 
 * applied to the TransformInstance.
 * 
 * In Here block_all === true and boolean values === false means leave it how it is after the 
 * transform.  Otherwise it may allow extra things through the transform didn't.
 */
export class TransformUpgradeFeature extends FloatingFeature {
  transform_filter: any = {};
  adaptation_id = "";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.transform_filter = obj.transform_filter ? obj.transform_filter : {};
      if (Object.keys(this.transform_filter).length === 0) {
        if (obj.transform_ids && obj.transform_ids.length > 0) {
          this.transform_filter["id"] = { "in": obj.transform_ids };
        }
        if (obj.transform_type && obj.transform_type.length > 0) {
          this.transform_filter["transform_type"] = { "in": [obj.transform_type] };
        }
      }
      this.adaptation_id = obj.adaptation_id ? obj.adaptation_id : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.transform_filter = obj.transform_filter ? obj.transform_filter : {};
  //     if (Object.keys(this.transform_filter).length === 0) {
  //       if (obj.transform_ids && obj.transform_ids.length > 0) {
  //         this.transform_filter["id"] = { "in": obj.transform_ids };
  //       }
  //       if (obj.transform_type && obj.transform_type.length > 0) {
  //         this.transform_filter["transform_type"] = { "in": [obj.transform_type] };
  //       }
  //     }
  //     this.adaptation_id = obj.adaptation_id ? obj.adaptation_id : "";
  //   }
  // }

  toDBObj(): any {
    const super_obj = super.toDBObj();
    return {
      ...super_obj,
      transform_filter: this.transform_filter,
      adaptation_id: this.adaptation_id
    };
  }

  clone(drop_ids = false): TransformUpgradeFeature {
    const clone = new TransformUpgradeFeature();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof TransformUpgradeFeature) {
      this.transform_filter = {...copyMe.transform_filter};
      this.adaptation_id = copyMe.adaptation_id;
    }
  }
}
